import React from 'react';
import {
  Alert,
  List,
  ListItem,
  ListItemText,
  Typography
} from '@mui/material';

const ExerciseLogDetails = ({ log }) => {
  return (
    <div>
      <List>
        {log && log.sets_and_reps.map((set, index) => (
          <ListItem key={index} style={{ border: "1px lightgrey solid", margin: "2px", borderRadius: "5px" }}>
            <ListItemText
              secondary={`${index + 1}. Ease: ${set.ease}, W: ${set.weight}, Reps: ${set.repetition}, Shoulder Pain: ${set.shoulder_pain}`}
            />
          </ListItem>
        ))}
      </List>
      {log.notes &&
        <Alert style={{ marginBottom: '10px' }} severity="success">{log.notes}</Alert>
      }

      <Alert severity="info">{new Date(log.performed_at).toLocaleString(undefined, {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </Alert>

    </div>
  );
};

export default ExerciseLogDetails;